const Pay = () => {
  return (
    <>
      <p>
        <strong>자동결제 동의 약관</strong>
        <br />
        <br />
        <strong>제1조 (약관의 적용)</strong>
        <br />
        신용카드, 직불카드(이하 ‘결제수단’)의 자동결제 방법(이하 ‘자동결제’라 한다)에​ 의하여 각종
        대금을 납부하고자 하는 자(이하 ‘고객’이라 한다)와 고객의 지급수단을 보유한 금융기관에 대하여
        이 약관을 적용합니다.
        <br />
        <br />
        <strong>제2조 (출금)</strong>
        <br />
        자동결제는 고객이 지급하여야 할 요금이 있는 경우 별도의 통지 없이 고객의 지정결제수단에서
        출금을 의뢰하는 기관(이하 '당사'라 한다)이 지정하는 납기일에 결제합니다. 다만, 자동결제의
        경우에는 금융기관의 약관이나 약정서의 규정에 불구하고 결제청구서, 기타 관련 증서 없이
        자동결제 처리절차에 의하여 결제할 수 있습니다.
        <br />
        <br />
        <strong>제3조 (과실책임)</strong>
        <br />
        자동 “결제수단”의 잔액 또는 한도(자동대출 약정이 있는 경우 대출한도 포함)가 결제일 현재
        “당사”의 청구금액보다 부족하거나, 결제의 지급제한, 연체 등 고객의 과실에 의하여 결제가
        불가능한 경우의 손해는 고객의 책임으로 한다.
        <br />
        <br />
        <strong>제4조 (결제일)</strong>
        <br />
        당사의 서비스의 자동결제를 신청한 고객의 서비스 대금 결제일은 서비스 갱신 시점으로 합니다.
        결제일에 잔액부족 등으로 결제가 되지 않은 경우에는 결제일로부터 3회 결제를 재시도 합니다.
        결제 실패 등으로 미납이 지속될 경우 당사는 서비스를 중단하고 미납된 금액에 대한 결제를
        요청할 수 있습니다.
        <br />
        <br />
        <strong>제5조 (결제주기)</strong>
        <br />
        회사가 정한 멤버십 구독료와 서비스 이용과 관련해 발생하는 기타 청구 금액 (예: 세금, 거래
        수수료 등)은 '계정' 페이지에 표시된 결제일에 등록된 결제 수단으로 청구됩니다. 결제 주기는
        회원이 멤버십 가입 시 선택한 멤버십 유형에 따라 결정됩니다. 등록된 결제 수단이 정상적으로
        처리되지 않거나, 특정 월에 존재하지 않는 날짜에 유료 멤버십이 시작된 경우이거나, 회원이
        멤버십 유형을 변하는 경우 등의 일부 상황에서는 요금 청구일이 변경될 수 있습니다.
        <br />
        <br />
        <strong>제6조 (결제수단)</strong>
        <br />
        멤버십 서비스를 이용하려면 하나 이상의 결제 수단을 제공해야 합니다. 미결제금액에 대한 책임은
        회원에게 있습니다. 유효기간 만료, 잔고 부족 등 사유로 결제가 정상적으로 처리되지 않았다면
        유효한 결제 수단에 청구가 완료될 때까지 회원의 서비스 이용이 제한될 수 있습니다.
        <br />
        <br />
        <strong>제7조 (결제수단 업데이트)</strong>
        <br />
        회원은 마이페이지로 이동하여 결제 수단을 업데이트할 수 있습니다. 회사에서도 해당 결제 서비스
        제공업체에서 제공하는 정보를 이용하여 회원의 결제 수단을 업데이트할 수 있습니다. 업데이트를
        하는 경우, 회원은 회사가 해당 결제 수단으로 계속 청구하는 것을 승인하는 것입니다. 회원은
        기본 결제 수단이 거부되거나 가입 요금 결제에 더 이상 사용될 수 없는 경우, 회사가 회원의
        계정에 연결된 다른 결제 수단으로 청구하는 것을 승인합니다.
        <br />
        <br />
        <strong>제8조 (출금우선순위)</strong>
        <br />
        납기일에 동일한 수종의 “자동결제” 청구가 있는 경우의 출금 우선 순위는 “금융​ 기관”에서
        정하는 바에 따릅니다.
        <br />
        <br />
        <strong>제9조 (최초 개시일)</strong>
        <br />
        “자동결제” 신규신청에 의한 결제개시일은 “당사”의 상품 구매 시 “자동결제” 동​ 의에 의하여
        결정되며 “당사”로부터 최초 상품 결제일을 최초 개시일로 합니다.
        <br />
        <br />
        <strong>제10조 (신청 및 취소)</strong>
        <br />
        “자동결제” 신규 신청은 해당 상품의 구매 결제 시 “자동결제”에 동의함으로 신청​ 서를 대체하며,
        취소 및 변경은 “당사” 어플 내 ‘마이페이지 &gt; 멤버십관리’에서 해당 상품 자동결제일 24시간
        전까지 변경을 하셔야 합니다.
        <br />
        <br />
        <strong>제11조 (결제기준 및 이의제기)</strong>
        <br />
        “자동결제” 신청에 의한 “결제수단”에서의 결제금은 해당 일에 청구된 청구금액​에 한하여
        “당사”의 청구대로 결제가 이루어지며, 청구금액에 이의가 있는 경우에​는 “고객”과 “당사”가
        조정하여야 합니다.
        <br />
        <br />
        <strong>제12조 (정보제공​)</strong>
        <br />
        “자동결제” 업무처리를 위하여 “자동결제”와 관련한 고객정보(신용카드정보, 직불​ 카드정보,
        법인인 경우 사업자등록번호, 개인인 경우 주민번호 일부 등)가 당사에 서비스 제공기간동안
        암호화되어 저장되며 제공된 정보에 대해 당사는 관련 업무 이외의 목적에 사용하지 않습니다.
        <br />
        <br />
        <strong>제13조 (약관 적용)</strong>
        <br />
        “자동결제” 신청을 “당사”의 온라인 서비스에서 동의하여 “자동결제”를 신청한 경​우 이 약관을
        적용합니다.
      </p>
    </>
  );
};

export default Pay;
